import { render } from "./LanguageSelector.vue?vue&type=template&id=452b7c28&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import "./LanguageSelector.vue?vue&type=style&index=0&id=452b7c28&scoped=true&lang=css"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452b7c28"]])

export default __exports__